import { createContext, useContext } from "react";

const DASHBOARD_SLUG_HEADER = "X-Slotique-Dashboard-Slug";
const LEGACY_DASHBOARD_SEGMENTS = new Set(["calendar", "clients", "pos", "settings"]);

export const DashboardActiveSlugContext = createContext<string | undefined>(undefined);

export function useDashboardActiveSlug(): string | undefined {
  return useContext(DashboardActiveSlugContext);
}

export function currentDashboardSlug(pathname = window.location.pathname): string | undefined {
  const match = pathname.match(/^\/dashboard\/([^/?#]+)(?:\/([^/?#]+))?/);
  const segment = match?.[1];
  if (!segment || (LEGACY_DASHBOARD_SEGMENTS.has(segment) && !match?.[2])) return undefined;
  return decodeURIComponent(segment);
}

function dashboardSectionFromPath(pathname = window.location.pathname): string {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] !== "dashboard") return "calendar";

  const first = segments[1];
  if (!first) return "calendar";
  if (LEGACY_DASHBOARD_SEGMENTS.has(first) && !segments[2]) return first;
  return segments[2] ?? "calendar";
}

export function dashboardSectionPath(slug: string, section = dashboardSectionFromPath()): string {
  return `/dashboard/${encodeURIComponent(slug)}/${section}`;
}

export function canonicalDashboardPath(pathname: string, slug: string): string {
  if (currentDashboardSlug(pathname)) {
    return pathname.replace(/^\/dashboard\/[^/]+/, `/dashboard/${encodeURIComponent(slug)}`);
  }
  return dashboardSectionPath(slug, dashboardSectionFromPath(pathname));
}

export function dashboardSectionTo(section = dashboardSectionFromPath()): string {
  const slug = currentDashboardSlug();
  return slug ? dashboardSectionPath(slug, section) : `/dashboard/${section}`;
}

export function dashboardRequestOptions(pathname = window.location.pathname) {
  const slug = currentDashboardSlug(pathname);
  return slug ? { headers: { [DASHBOARD_SLUG_HEADER]: slug } } : {};
}

export function dashboardRequestOptionsForSlug(slug: string | undefined) {
  return slug ? { headers: { [DASHBOARD_SLUG_HEADER]: slug } } : {};
}
